module.exports = __webpack_public_path__ + "img/4-text.ad92b238.png";